// The two small pieces of the registry's vocabulary the browser's client needs at once: what each refusal is
// called on the wire, and whether two sets of changed things overlap. Kept apart from `spec.ts` (which carries Zod
// for defining actions) so the first screen doesn't load it. Re-exported from `spec.ts`.

import type { ErrorCode } from "@adea/schemas";
import type { ObjectRef } from "./spec";

/** Every refusal has a typed code. The app shows the designed screen for each. */
export const ERROR_STATUS = {
  invalid_input: 400,
  unauthenticated: 401,
  plan_required: 402,
  /** The month's analysis is used up (people's pool past its ceiling): it renews on the 1st, or an admin adds more. */
  usage_limit: 402,
  forbidden: 403,
  guardian_held: 403,
  confirmation_invalid: 403,
  unknown_action: 404,
  not_available_here: 404,
  not_found: 404,
  conflict: 409,
  /** The run this call belonged to was stopped. */
  cancelled: 409,
  confirmation_required: 428,
  rate_limited: 429,
  /** Adea is busy with too much at once for the company; try again in a moment. */
  busy: 429,
  internal: 500,
  guardian_unavailable: 503,
} as const satisfies Partial<Record<ErrorCode, number>>;
export function refsIntersect(a: readonly ObjectRef[], b: readonly ObjectRef[]): boolean {
  return a.some((x) =>
    b.some((y) => x.type === y.type && (x.id === undefined || y.id === undefined || x.id === y.id)),
  );
}
